import React from 'react';
import Switch from 'react-switch';

export default function Toggle({
  /**
   * Checked
   */
  checked = false,
  /**
   * propagate change event
   */
  onChange,
}) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      onColor="#00BEC1"
      onHandleColor="#fff"
      handleDiameter={20}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
      height={13}
      width={35}
      className="react-switch"
    />
  );
}
